import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatProgressBar } from '@angular/material/progress-bar';
import { RouterOutlet } from '@angular/router';

import { DevicesList } from '../../../entities/models/devices.model';
import { FirmwarePackageDTO } from '../../../infrastructure/backends/firmware-package.dto';
import {
  ProductGroupPercentages,
  RolloutPlanDTO
} from '../../../infrastructure/backends/rollout-plan.dto';
import {
  PackageChangeHistoryDto,
  ProductGroupStatistics,
  RolloutPlanChangeHistoryDto
} from '../../../infrastructure/types';
import { EmptyState } from '../empty-state/empty-state';
@Component({
  selector: 'remote-update-domain-app-page-wrapper',
  templateUrl: './page-wrapper.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CommonModule, RouterOutlet, MatProgressBar, EmptyState]
})
export class PageWrapper {
  @Input() data:
    | RolloutPlanDTO[]
    | DevicesList[]
    | PackageChangeHistoryDto[]
    | FirmwarePackageDTO[]
    | ProductGroupStatistics[]
    | ProductGroupPercentages[]
    | RolloutPlanChangeHistoryDto[]
    | null = [];
  @Input() hasError = false;
  @Input({ required: true }) emptyTitle = '';
  @Input({ required: true }) emptyDescription = '';
  @Input() isLoading = false;
  @Input() bgColor = 'bg-[#f7f9ff]';
  @Input() paddingX = 'px-200-rem';

  @Input() height = '';
}
